export enum LocalStorageKey {
    SessionToken = "pg.session-token",
    WalletProvider = "pg.wallet",
    CustomerInsights = "customer-insights-modal",
    WalletCurrencyUsd = "pg.wallet-currency-usd",
    WalletHideZeros = "pg.wallet-hide-zeros",
    CurrencyAsset = "asset",
}